export default {
  awsConfigs: {
    acni: {
      'aws_app_analytics': 'enable',
      'aws_cloud_logic': 'enable',
      'aws_cloud_logic_custom': [{"id":"n2h7o1jxm9","name":"NamedAccont","description":"","endpoint":"https://n2h7o1jxm9.execute-api.us-west-2.amazonaws.com/prd","region":"us-west-2","paths":["/api/m/billOfLoads/create","/api/m/billOfLoads/get","/api/m/billOfLoads/getByLoadId","/api/m/images","/api/m/loads/complete","/api/m/loads/get","/api/m/loads/incomplete","/api/m/loads/search","/api/m/loads/yardSearch","/api/m/loads/yardUpdate","/api/m/masterData","/api/m/qcProblems/create","/api/m/schedules","/api/m/schedules/yardSearch","/api/m/users/me","/api/w/aws/send","/api/w/billOfLoads","/api/w/billOfLoads/confirm","/api/w/billOfLoads/save","/api/w/callLogs","/api/w/callLogs/action","/api/w/excel/generate","/api/w/loads","/api/w/loads/save","/api/w/loads/updateQcStatus","/api/w/masterData","/api/w/masterData/update","/api/w/schedules","/api/w/schedules/assignLoad","/api/w/schedules/save","/api/w/sqs/send","/api/w/stores","/api/w/stores/searchOptions","/api/w/stores/special/action","/api/w/users","/api/w/users/create","/api/w/users/me","/api/w/users/update","/api/w/yardQc"]}],
      'aws_cognito_identity_pool_id': 'us-west-2:9e37a75b-13fc-4add-a214-dcff343653a7',
      'aws_cognito_region': 'us-west-2',
      'aws_content_delivery': 'enable',
      'aws_content_delivery_bucket': 'walmartprd-hosting-mobilehub-492072795',
      'aws_content_delivery_bucket_region': 'us-west-2',
      'aws_content_delivery_cloudfront': 'enable',
      'aws_content_delivery_cloudfront_domain': 'd2pds41j687jxf.cloudfront.net',
      'aws_mandatory_sign_in': 'enable',
      'aws_mobile_analytics_app_id': '76487fd3fccc40eb9849a235ba6189d4',
      'aws_mobile_analytics_app_region': 'us-east-1',
      'aws_project_id': 'd6b6180f-5a8f-40b3-93ba-1e8052547854',
      'aws_project_name': 'WALMART_PRD',
      'aws_project_region': 'us-west-2',
      'aws_resource_name_prefix': 'walmartprd-mobilehub-492072795',
      'aws_sign_in_enabled': 'enable',
      'aws_user_pools': 'enable',
      'aws_user_pools_id': 'us-west-2_5ujFrCtGp',
      'aws_user_pools_mfa_type': 'OFF',
      'aws_user_pools_web_client_id': '7oi4knsu8d5egfpo2fk0q2rmlb',
    }
    ,
  },
  env: 'prd',
  appLinks:{
    android:{
      walmart: 'https://s3-us-west-2.amazonaws.com/app-s3-walmart/walmartPRD/appWalmartPRD.apk',
      yard: 'https://s3-us-west-2.amazonaws.com/app-s3-walmart/yardPRD/appYardPRD.apk'
    },
    ios:{
      walmart: 'https://s3-us-west-2.amazonaws.com/app-s3-walmart/walmartPRD/main.html',
      yard: 'https://s3-us-west-2.amazonaws.com/app-s3-walmart/yardPRD/main.html'
    },
  },
};
